import { useFormContext } from 'react-hook-form'
import { FormField } from '@/components/serge/FormField'
import { type LegalEntityFormData } from '@/lib/legalEntitySchema'

export function GeneralInfoStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<LegalEntityFormData>()

  return (
    <div className="space-y-6">
      <div className="border border-border bg-surface p-5">
        <h3 className="text-lg font-semibold text-foreground mb-1">Informations générales</h3>
        <p className="text-sm text-foreground-secondary mb-6">
          Identité juridique de votre entreprise
        </p>

        <div className="space-y-4">
          <FormField
            label="Nom interne"
            required
            error={errors.name}
            hint="Nom court pour identifier cette entité dans Serge"
            tooltip="Ce nom est utilisé uniquement dans l'interface Serge pour faciliter la gestion de plusieurs entités"
          >
            <input
              {...register('name')}
              className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
              placeholder="Ex: Holding Sigma"
            />
          </FormField>

          <FormField
            label="Raison sociale"
            error={errors.legalName}
            hint="Dénomination officielle telle qu'enregistrée"
            tooltip="Nom complet de l'entreprise tel qu'il apparaît sur les documents officiels (Kbis, statuts, etc.)"
          >
            <input
              {...register('legalName')}
              className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
              placeholder="Ex: Sigma Holdings SAS"
            />
          </FormField>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Forme juridique"
              error={errors.legalForm}
              tooltip="Type de structure juridique (SAS, SARL, SCI, Association, etc.)"
            >
              <input
                {...register('legalForm')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="Ex: SAS, SARL, EURL..."
              />
            </FormField>

            <FormField
              label="Capital social"
              error={errors.capital}
              tooltip="Montant du capital social avec la devise (ex: 10 000 EUR)"
            >
              <input
                {...register('capital')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="Ex: 10 000 EUR"
              />
            </FormField>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="SIREN / SIRET"
              error={errors.registrationNumber}
              hint="9 chiffres (SIREN) ou 14 chiffres (SIRET)"
              tooltip="Numéro d'identification unique attribué par l'INSEE"
            >
              <input
                {...register('registrationNumber')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground font-mono focus:outline-none focus:border-primary transition"
                placeholder="Ex: 123456789 ou 12345678900012"
              />
            </FormField>

            <FormField
              label="Numéro de TVA"
              error={errors.vatNumber}
              tooltip="Numéro de TVA intracommunautaire (si applicable)"
            >
              <input
                {...register('vatNumber')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground font-mono focus:outline-none focus:border-primary transition"
                placeholder="Ex: FR12345678901"
              />
            </FormField>
          </div>
        </div>
      </div>
    </div>
  )
}
